import { useEscapeKey } from '../../utils/hooks/useEscapeKey';
import PortalComponent from '../Portal';
import styles from './Modal.module.scss';

export default function ModalComponent({ show, hideModal, children }) {
    const handleChildElementClick = (e) => {
        e.stopPropagation();
    };

    useEscapeKey(hideModal);

    return (
        <PortalComponent>
            {show && (
                <div className={styles.modalOpacity} onClick={hideModal}>
                    <div className={styles.modalWrapper}>
                        <div className={styles.modalContainer} onClick={handleChildElementClick}>
                            {children}
                        </div>
                    </div>
                </div>
            )}
        </PortalComponent>
    );
}
